export const COMPANY_USER_TAG_NAME = 'tm-company-user';
